<!-- Sans [color] : le bouton prend la couleur de texte de la barre (--mho-topbar-fg). En
     « accent », il prenait celle de l'accent, illisible sur la barre en mode clair et à Noël. -->
@if (badges().length === 0) {
    @if (isCompact()) {
        <button mat-icon-button type="button" (click)="update()"
                matTooltip="Mettre à jour" i18n-matTooltip="@@mho_update_label">
            <mat-icon>send</mat-icon>
        </button>
    } @else {
        <button mat-button type="button" (click)="update()">
            <mat-icon>send</mat-icon>
            <ng-container i18n="@@mho_update_label">Mettre à jour</ng-container>
        </button>
    }
} @else {
    <button mat-button type="button" class="tools-progress" (click)="update()">
        @for (badge of badges(); track badge.name) {
            <span class="tool" [matTooltip]="badge.tooltip" matTooltipClass="mho-multiline-tooltip">
                <img [src]="badge.icon" [alt]="badge.name" height="16" width="16">
                <span class="badge" [class.pending]="badge.status === 'pending'"
                      [class.success]="badge.status === 'success'"
                      [class.error]="badge.status === 'error'">
                    @switch (badge.status) {
                        @case ('pending') {
                            …
                        }
                        @case ('success') {
                            ✔
                        }
                        @default {
                            ✖
                        }
                    }
                </span>
            </span>
        }
    </button>
}
